import React from "react";
import { useContext } from "react";
import { LandingPageWrapper } from "./_styles/LandingPageWrapper";
import moneyImg from "../../assets/images/EPL_think_images/Landing_Page_money.png";
import stepIcon1 from "../../assets/svg/EPL_think_svg/Landing_Page/Step_Icon_1.svg";
import stepIcon2 from "../../assets/svg/EPL_think_svg/Landing_Page/Step_Icon_2.svg";
import stepIcon3 from "../../assets/svg/EPL_think_svg/Landing_Page/Step_Icon_3.svg";
import stepIcon4 from "../../assets/svg/EPL_think_svg/Landing_Page/Step_Icon_4.svg";
import LoanExpired from "../../assets/svg/EPL_think_svg/loan_expired.svg";
import Button from "../../components/core/EPL_Button_Think";
// import { useHistory, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import carouselImage1 from "../../assets/images/EPL_think_images/Landing_Page/01_Travel.png";
import carouselBanner1 from "../../assets/images/EPL_think_images/Landing_Page/01_banner.png";
import carouselBanner2 from "../../assets/images/EPL_think_images/Landing_Page/02_banner.png";
import carouselBanner3 from "../../assets/images/EPL_think_images/Landing_Page/03_banner.png";
import carouselBanner4 from "../../assets/images/EPL_think_images/Landing_Page/04_banner.png";
import carouselBanner5 from "../../assets/images/EPL_think_images/Landing_Page/05_banner.png";
import Carousel from "../../components/advance/Carousel";
import { InvalidURLModal, SafariCheckModal } from "../other-pages/Modals/AllModal";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import Accordion from "./Accordion";
import { isValidSearchParams } from "../../shared/validations/SearchParams";
// import GetCustomerDetailsContext from "../../App"

// const LandingPageCarousel = ({ index, history, location }) => {
const LandingPageCarousel = ({ index, navigate, location }) => {
  const images = [
    carouselBanner1,
    carouselBanner2,
    carouselBanner3,
    carouselBanner4,
  ];
  const carouselMessage = [
    "Tick off all the places on your travel bucket list",
    "Achieve your aspirations without any setbacks!",
    "Give your home the elegant transormation you desire",
    "Your dreams of having an extravagant wedding can be a reality!",
  ];
  const source = location.pathname.split("/")[1]; // "epl"

  return (
    <>
      {/* <div className="index-carousel-message">
        Need an instant Personal Loan to Travel?
      </div>
      <div className="index-carousel-cta">
        <button
          onClick={() => {
            // history.push({
            //   pathname: `/login`,
            //   search: location.search,
            // });
            var route = getRouteFromLoanStageService({
              source: source,
              stage: "",
            });
            // console.log("stage: ", customerDetails.stage);
            // console.log("route: ", route);
            navigate(`${route}`, {
              replace: true,
              state: {
                customerDetails: customerDetails,
              },
            });
          }}
        >
          Apply
        </button>
      </div> */}
      <Carousel
        images={images}
        carouselMessage={carouselMessage}
        index={index}
        navigate={navigate}
        source={source}
      />
    </>
  );
};

const EPL = () => {
  // const history = useHistory();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  // const dsa_hash = searchParams.get("dsa_hash");
  //   const [customerDetails, setCustomerDetails] = useContext(
  //     GetCustomerDetailsContext
  //   );
  const source = location.pathname.split("/")[1]; // "epl"
  //   useEffect(() => {
  //     // console.log("location: ", location.pathname); // "/epl/login"
  //     // console.log("location: ", location.pathname.split("/")); // ["", "epl", "login"]
  //     // console.log("location: ", source);
  //     // setCustomerDetails({
  //     //   ...customerDetails,
  //     //   source: source,
  //     // });
  //   }, [])

  const [isSafari, setIsSafari] = useState(false);
  const [urlParams, setUrlParams] = useState("");
  const [showInvalidURLModal, setShowInvalidURLModal] = useState(false);

  useEffect(() => {
    if (isValidSearchParams() && searchParams.get("dsa_hash")) {
      setUrlParams(window.location.search);
    } else {
      setShowInvalidURLModal(true);
    }
  }, []);

  useEffect(() => {
    let details = navigator.userAgent;
    if (/safari/i.test(details) && !/chrome/i.test(details)) {
      setIsSafari(true);
    }
  }, []);

  const FloatingButton = ({ source }) => (
    <>
      <div
        style={{
          display: "flex",
          position: "fixed",
          bottom: "10px",
          justifyContent: "center",
          zIndex: 5,
          justifyContent: "center",
          width: "100%",
          pointerEvents: "none",
        }}
      >
        <Button
          id="cta-button"
          className="cta-button"
          style={{
            pointerEvents: "all",
          }}
          onClick={() => {
            var route = getRouteFromLoanStageService({
              source: source,
              stage: "",
            });
            // console.log("stage: ", customerDetails.stage);
            // console.log("route: ", route);
            if (urlParams) {
              const url = `${route}${urlParams}`;
              navigate(url, {
                replace: true,
                // state: {
                // 	customerDetails: customerDetails,
                // },
              });
            } else {
              const url = `${route}`;
              navigate(url, {
                replace: true,
                // state: {
                // 	customerDetails: customerDetails,
                // },
              });
            }
          }}
          text={"Apply Now"}
        />
      </div>
    </>
  );

  return (
    <>
      <FloatingButton source={source} />
      <LandingPageWrapper>
        <InvalidURLModal
          isOpen={showInvalidURLModal}
          modalImage={LoanExpired}
          onClose={() => { }}
        />
        <SafariCheckModal
          isOpen={isSafari}
          onClose={() => {
            setIsSafari(false);
          }}
        />
        <div className="index-layout">
          <div className="index-title-container">
            {source === "upsell"
              ? "Top Up Loan for Salaried Employees"
              : (<>Instant Personal Loan for Salaried Employees <br/> & Self-Employed Professionals</>)}
          </div>
          <div className="index-carousel">
            <LandingPageCarousel
              index={0}
              // history={history}
              navigate={navigate}
              location={location}
            />
          </div>
          <div className="index-description">
            <span>
              Avail an{" "}
              <span>
                {source === "upsell" ? "Top Up Loan" : "Instant Personal Loan"}
              </span>{" "}
              of up to <span>&#8377;7,00,000</span> in four steps
            </span>
          </div>
          <div className="index-steps">
            <span>
              <div className="index-steps-icon-container">
                <img src={stepIcon1} />
              </div>
              <div className="index-steps-line index-steps-line-first"></div>
              <span>
                {source === "upsell"
                  ? "Verify your existing details"
                  : "Provide your Personal and Employment details"}
              </span>
            </span>
            <span>
              <div className="index-steps-icon-container">
                <img src={stepIcon2} />
              </div>
              <div className="index-steps-line"></div>
              <span>Select a loan amount and tenure</span>
            </span>
            <span>
              <div className="index-steps-icon-container">
                <img src={stepIcon3} />
              </div>
              <div className="index-steps-line"></div>
              <span>Verify your loan agreement and provide an e-consent</span>
            </span>
            <span>
              <div className="index-steps-icon-container">
                <img src={stepIcon4} />
              </div>
              <div className="index-steps-line index-steps-line-last"></div>
              <span>Get an instant loan disbursal</span>
            </span>
          </div>
          {source === "upsell" ? (
            <></>
          ) : (
            <>
              <div className="index-documents-card">
                <h2>Keep the following documents ready</h2>
                <div className="index-documents-list">
                  <ul>
                    <li>PAN and Aadhaar number</li>
                    <li>Bank Details for Loan disbursement</li>
                  </ul>
                  <img src={moneyImg} height="100" width="100" />
                </div>
              </div>
            </>
          )}

          <div
            className="accordion-container"
            // style={{ paddingBottom: "70px" }}
          >
            <Accordion
              title={
                source === "upsell" ? "Top Up Loan FAQs" : "Personal Loan FAQs"
              }
              headerClassName="mainHeader"
              contentClassName="mainContent"
              content={
                source === "upsell" ? (
                  <>
                    <Accordion
                      title="How can I apply?"
                      content={
                        <>
                          A. You can apply for the Top Up Loan by following the
                          steps given below:
                          <li>Open the digital journey mobile web URL link</li>
                          <li>
                            Login using your Mobile Number through OTP based
                            authentication process to view your offer
                          </li>
                          <li>
                            Verify your Personal Details and Professional
                            Details
                          </li>
                          <li>Choose your desired Amount and Tenure</li>
                          <li>
                            Complete e-KYC process (in case there is an address
                            change)
                          </li>
                          <li>Check and Confirm Bank Details</li>
                          <li>Register for the eNACH mandate</li>
                          <li>
                            Accept the digital loan agreement Voila! Your loan
                            will be disbursed to your account
                          </li>
                        </>
                      }
                    />
                    <Accordion
                      title="What are the minimum and maximum loan amounts?"
                      content={
                        <>
                          Minimum loan amount that can be availed is ₹50,000 &
                          Maximum loan amount is ₹10 Lakhs. The maximum amount
                          can differ from person to person based on the
                          eligibility criteria
                        </>
                      }
                    />
                    <Accordion
                      title="What are the eligibility requirements for availing Top Up Loan?"
                      content={
                        <>
                          You should be meeting internal policy criterion for
                          Top Up Loan
                        </>
                      }
                    />
                    <Accordion
                      title="What is the tenure of a Top Up loan?"
                      content={
                        <>
                          The repayment schedule varies up to 60 months
                          depending on your top-up offer
                        </>
                      }
                    />
                    <Accordion
                      title="How do I contact for any queries?"
                      content={
                        <>
                          In case of any query, please reach out to us at
                          Care.digitalfinance@adityabirlacapital.com with the application
                          reference number.
                        </>
                      }
                    />
                  </>
                ) : (
                  <>
                    <Accordion
                      title="How can I apply?"
                      content={
                        <>
                          You can apply for the Personal Loan by following the
                          steps given below:
                          <li>Open the digital journey mobile web URL link</li>
                          <li>
                            Login using your Mobile Number through OTP based
                            authentication process
                          </li>
                          <li>
                            Enter your Personal Details and Professional Details
                          </li>
                          <li>
                            Upload your last 6 months salary account bank
                            statement
                          </li>
                          <li>Choose your desired Amount and Tenure</li>
                          <li>Complete e-KYC process</li>
                          <li>Check and Confirm Bank Details</li>
                          <li>Register for the eNACH mandate</li>
                          <li>Provide Reference Details</li>
                          <li>
                            Accept the digital loan agreement Voila! Your loan
                            will be disbursed to your account
                          </li>
                        </>
                      }
                    />
                    <Accordion
                      title="What are the minimum and maximum loan amounts?"
                      content={
                        <>
                          Minimum loan amount that can be availed is ₹50,000 &
                          Maximum loan amount is ₹7 Lakhs. The maximum amount
                          can differ from person to person based on the
                          eligibility criteria.
                        </>
                      }
                    />
                    <Accordion
                      title="What are the eligibility requirements for availing Personal Loan?"
                      content={
                        <>
                          You should be meeting internal policy criterion for
                          Personal Loan.
                        </>
                      }
                    />
                    <Accordion
                      title="What is the tenure of a personal loan?"
                      content={
                        <>
                          The repayment schedule varies up to 36 months
                          depending on the loan amount chosen. You will have
                          flexibility to choose your tenure for a particular
                          amount of loan.
                        </>
                      }
                    />
                    <Accordion
                      title="How does the loan repayment will be initiated?"
                      content={
                        <>
                          Your EMI amount will get deducted from the account
                          basis the setup done at the time of eNACH mandate
                          registration
                        </>
                      }
                    />
                    <Accordion
                      title="What are the fees, charges, and interest rates applicable?"
                      content={
                        <>
                          Interest rate along with applicable EMIs is shown to
                          you during the loan application before availing the
                          Loan. The interest rate starts at just 10.99%* p.a.
                          You will get the loan with 1-3.5% processing fees.
                        </>
                      }
                    />
                    <Accordion
                      title="How do I contact for any queries?"
                      content={
                        <>
                          In case of any query, please reach out to us at
                          Care.digitalfinance@adityabirlacapital.com with the application
                          reference number.
                        </>
                      }
                    />
                    <Accordion
                      title="How can I post my grievance?"
                      content={
                        <>
                          You can lodge your complaints by emailing your request to Care.digitalfinance@adityabirlacapital.com. In case of escalations, you can check the <a href="https://personalfinance.adityabirlacapital.com/_layouts/15/abc.finplf/grievencenew.aspx">Escalation Matrix </a>for grievance redressal at Aditya Birla Capital Limited.
                        </>
                      }
                    />
                  </>
                )
              }
            />
          </div>

          <div className="illus">
            <h3>Illustration:</h3>
              <p>
              Annual Percentage Rate offered to customer Min APR – 10.99%. Max APR – 28.00%. (T&C Apply). Tenure: Min 12 months, Max 36 months. Processing fee: Up to 3.5% (Excluding GST).
              </p>

              <p id = "illus1">Sample Calculation: On a term personal loan for ₹1 Lakh at rate of 10.99% per annum, for a tenor of 36 months, the EMI amount excluding the processing fee will be ₹3,273/-. Loan disbursal at sole discretion of Aditya Birla Capital Limited.</p>
          </div>
        </div>
      </LandingPageWrapper>
    </>
  );
};

export default EPL;
